/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { contactResponseDtoSchema } from "./contactResponseDtoSchema";
import { z } from "zod/v4";

export const paginatedContactsResponseDtoSchema = z.object({
    get "items"(){
                return z.array(contactResponseDtoSchema)
              },
"total": z.number(),
"pageNumber": z.number(),
"pageSize": z.number(),
"nextPage": z.nullable(z.string())
    })